export const translations = {
	'Images': {},
	'Icons': {},
	'Choose an image': {},
	'Choose': {},
	'Upload': {},
	'The library has no images yet. Upload one, or drop it here.': {},
	'Delete the image?': {},
	'It goes from the library, and from every dashboard that shows it.': {},
	'Only JPG, PNG and GIF images up to 5 MB can be uploaded': {},
	'Search icons': {},
	'No icon matches the search': {},
	'Outlined': {},
	'Filled': {},
	'Two tone': {},
	'Directional': {},
	'Suggested': {},
	'Editor': {},
	'Data': {},
	'Brands and logos': {},
	'Other': {},
};
